export const FEATURE_FLAG_FRESH_ELIGIBILITY = 'fresh_eligibility';
export const FEATURE_FLAG_ULTRA_FRESH_ELIGIBILITY = 'ultra_fresh_eligibility';
export const FEATURE_FLAG_ACCOUNT_WARNING = 'my_account_warning';
export const FEATURE_FLAG_PAYPAL_SUBSCRIPTION = 'paypal_subscription';
export const FEATURE_FLAG_PAYPAL_MAAP = 'paypal_maap';
export const BRANDS_SEARCH_RESULTS = 'brands_search_results';
export const GENERIC_FUNNEL_STEPPER_WORDING_EXPERIMENT =
  'generic_funnel_stepper_wording';
export const FEATURE_FLAG_NEW_MEMBERSHIP_PRODUCT_CART =
  'new_membership_product_cart';
export const GENERIC_FUNNEL_MERGE_PAYMENTS_EXPERIMENT =
  'generic_funnel_merge_payments';
export const FEATURE_FLAG_FIRST_ORDER_FORM = 'first_order_form';
export const FEATURE_FLAG_WEB_FIRST_ORDER_FORM = 'web_1st_order_form';
export const FEATURE_FLAG_MAPBOX_AUTO_COMPLETE = 'mapbox_autocomplete';
export const FEATURE_FLAG_GOOGLE_SHOPPING_ENABLED =
  'is_google_shopping_enabled';
export const ABTEST_MOBILE_APP_PRELIMINARY_STEPS =
  'abtest_register-preliminary-steps';
export const EXPIRED_CARD_BANNER = 'abtest_expired_card_banner';
export const ABTEST_UPDATE_PAYMENT_METHOD = 'abtest_update_payment_method';
export const FEATURE_FLAG_COLLECTION_HUB = 'collection_hub';
export const FEATURE_FLAG_OPEN_CATALOG = 'app_unlock_catalog_before_register';
export const FEATURE_FLAG_TRUSTPILOT_FOOTER_TEMPLATE =
  'trustpilot_footer_template';
export const FEATURE_FLAG_TRUSTPILOT_GENERIC_REGISTER_TEMPLATE =
  'trustpilot_generic_register_template';
export const ABTEST_MOBILE_SHIPPING_STICKY_CTA = 'checkout_shipping_sticky_cta';
export const ABTEST_CHECKOUT_INPUTS_ORDERING = 'abtest_checkout_input';
export const ABTEST_PAYMENT_PAGE_CTA_ALWAYS_ACTIVE =
  'checkout_payment_page_cta_always_active';
export const ABTEST_UNPRESELECT_SHIPPING_METHOD =
  'checkout_unpreselect_shipping_method';
export const FEATURE_FLAG_MULTI_CAROUSEL_V2 = 'feature_multi_carousel_v2';
export const CHECKOUT_ADDRESS_FORM_CTA_ALWAYS_ACTIVE =
  'checkout_address_form_cta_always_active';
export const ABTEST_NEW_404_PAGE = 'abtest_new_404_page';
export const ABTEST_CHECKOUT_PAYMENT_TEXT_POSITION =
  'checkout_payment_text_position';
export const ABTEST_CHECKOUT_PAYMENT_MAAP_BLOCK = 'checkout_payment_maap_block';
export const ABTEST_CHECKOUT_DELIVERY_REMOVE_MAAP_BLOCK =
  'checkout_delivery_remove_maap_block';
export const ABTEST_CHECKOUT_PAYMENT_CTA_FROM_STICKY_INTO_SUMMARY =
  'checkout_payment_cta_from_sticky_into_summary';
export const ABTEST_DELIVERY_BAR = 'abtest_delivery_bar';
export const FEATURE_CHECKOUT_ROUND_UP = 'checkout_round_up';
export const FEATURE_CHECKOUT_ROUND_UP_LABEL = 'checkout_round_up_label';
export const ABTEST_CHECKOUT_MONTHLY_MEMBERSHIP = 'checkout_monthly_membership';
export const ABTEST_REORDER_PAGE = 'abtest_re_order_page';
export const CONFIG_ALGOLIA_GROUPING_DEBOUNCER_TIME =
  'engineering_config_algolia_grouping_debouncer_time';
export const ABTEST_STROKE_PRICE = 'abtest_stroke_price';
export const FEATURE_FLAG_PIG_WITHOUT_FREQUENCY = 'pig_without_frequency';
export const ABTEST_PRODUCT_CARD_RATINGS = 'abtest_product_card_ratings';
export const FEATURE_FLAG_REFERRAL_UNIQUE_CODE = 'feature_referral_unique_code';
export const FEATURE_FLAG_REFERRAL_HOME_UID =
  'marketing_config_referral_home_cms_uid';
export const ABTEST_REGISTER_FLOW = 'abtest_register_flow';
export const ABTEST_APPLE_PAY = 'abtest_apple_pay';
export const ABTEST_APPLE_PAY_MOBILE = 'abtest_apple_pay_mobile';
export const AB_TEST_FEATURE_FLAG_MULTILINE_CHIPS = 'abtest_multiline_chips';
export const ABTEST_APP_NAVIGATION = 'abtest_app_navigation';
export const FEATURE_FLAG_ROLLOUT_PRODUCT_SCREEN_PARTIAL_PRODUCT =
  'engineering_rollout_product_screen_partial_product';
export const ABTEST_CLICKABLE_BRAND_PRODUCT_PAGE =
  'abtest_clickable_brand_product_page';
export const FEATURE_FLAG_SHELF_IN_PRODUCT_PAGE =
  'feature_flag_shelf_in_product_page';
export const ABTEST_PUSH_NOTIFICATIONS_CONSENT_MODAL = [
  'abtest_push_notifications_consent_modal',
  {
    land_on_HP_after_1st_log_in: 'land_on_HP_after_1st_log_in',
    oos: 'opt_in_oos',
    order: 'opt_in_order_completed',
  },
] as const;
export const ABTEST_APPSEARCHFOCUS = 'abtest_appsearchfocus';
export const CONFIG_GTM = 'gtm_config';
export const TOAST_NEXT_ZW_SLOT = 'toast_next_zw_slot';
export const FEATURE_FLAG_COBBAI_CHATBOT = 'cobbai-chatbot';
export const FEATURE_FLAG_FORCE_COOKIE_CONSENT = 'force_cookie_consent';
export const ABTEST_LATE_ADD_TO_CART = 'abtest_late_add_to_cart';
export const FEATURE_FLAG_RELEASE_DISPLAY_YUKASCORE =
  'release-product-page-yuka-score';
export const ABTEST_CHECKOUT_FLOW_FOR_CHECKOUT =
  'abtest_checkout_flow_for_checkout';
export const ABTEST_CHECKOUT_FLOW_FOR_GENERIC_FUNNEL =
  'abtest_checkout_flow_for_generic_funnel';
